<template>
  <v-row no-gutters>
    <v-col cols="12">
      <app-ag-grid
        title="Purchases"
        :columnDefs="columnDefs"
        :rowData="purchases"
        :loading="loading"
        @refresh="fetchPurchases"
        @add="onAdd"
        :mobileCard="mobileCard"
        @row-dbl-click="
          (data) => $router.push({ path: `purchases/${data._id}/edit` })
        "
      />
    </v-col>
  </v-row>
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "PurchasesPage",
  components: {
    AppAgGrid,
  },

  data() {
    return {
      loading: false,
      columnDefs: [
        {
          headerName: "View",
          field: "_id",
          minWidth: 80,
          cellRenderer: (params) => {
            return `
              <i
                class="mdi mdi-eye view-purchase"
                data-id="${params.data._id}"
                title="View Purchase"
                style="
                  cursor: pointer;
                  font-size: 18px;
                  color: #0a5a90;
                "
              ></i>
            `;
          },

          onCellClicked: (params) => {
            if (params.event.target.classList.contains("view-purchase")) {
              this.$router.push({ path: `purchases/${params.data._id}/view` });
            }
          },
        },
        { headerName: "Bill Number", field: "billNumber", minWidth: 130 },
        { headerName: "Vendor", field: "vendor.name", minWidth: 160 },
        {
          headerName: "Bill Date",
          field: "billDate",
          minWidth: 120,
          valueFormatter: (p) => this.formatDate(p.value),
        },
        {
          headerName: "Subtotal",
          field: "subtotal",
          minWidth: 140,
          valueFormatter: (p) => this.formatCurrency(p.value),
        },
        {
          headerName: "GST",
          field: "gst",
          minWidth: 120,
          valueFormatter: (p) => this.formatCurrency(p.value),
        },
        {
          headerName: "Amount",
          field: "totalAmount",
          minWidth: 140,
          valueFormatter: (p) => this.formatCurrency(p.value),
        },
        { headerName: "Status", field: "status", minWidth: 120 },
        { headerName: "Note", field: "note", minWidth: 200 },
        { headerName: "User", field: "userId.name", minWidth: 180 },
        { headerName: "Email", field: "userId.email", minWidth: 220 },
      ],
    };
  },

  computed: {
    purchases() {
      return this.$store.state.purchases.list || [];
    },

    mobileCard() {
      const statusColors = {
        PAID: { background: "#e6f7ec", color: "#15803d" },
        PARTIALLY_PAID: { background: "#e6f0fb", color: "#0a5a90" },
        PENDING: { background: "#fff7e6", color: "#b8720a" },
        CANCELLED: { background: "#fdecea", color: "#c62828" },
      };

      return {
        title: (row) => `#${row.billNumber}`,
        subtitle: (row) => row.vendor?.name || "-",
        badge: (row) => ({
          text: row.status || "-",
          style: statusColors[row.status] || { background: "#f1f5f9", color: "#475569" },
        }),
        fields: (row) => [
          { label: "Amount", value: this.formatCurrency(row.totalAmount) },
          { label: "Bill Date", value: this.formatDate(row.billDate) },
        ],
        actions: (row) => [
          {
            label: "View",
            icon: "mdi-eye-outline",
            color: "#0a5a90",
            onClick: () => this.$router.push({ path: `purchases/${row._id}/view` }),
          },
          {
            label: "Edit",
            icon: "mdi-pencil-outline",
            color: "#475569",
            onClick: () => this.$router.push({ path: `purchases/${row._id}/edit` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchPurchases();
  },

  methods: {
    async fetchPurchases() {
      this.loading = true;
      try {
        await this.$store.dispatch("purchases/getPurchases");
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    onAdd() {
      this.$router.push({ path: "purchases/create" });
    },

    formatCurrency(value) {
      if (value == null) return "-";
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
      }).format(value);
    },

    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
};
</script>
